import React, { Component } from "react";
import '../css/documentation.scss';

export class ViewContestHelp extends Component {
    render() {
        return (
            <div className="main-content">
                <div className="section__content section__content--p30 createContent">
                    <div className="container-fluid">
                        <h1 style={{ fontSize: '36px', marginTop: '30px' }}>How To View Contest Details</h1>
                        <p className="dateFormat" style={{ fontSize: '14px', color: 'grey' }}>18/11/2021 ▪ 2 minutes to read</p>
                        <br /><br />
                        <div class="webMgmt container-fluid">
                            <ol>
                                <li class="createList">
                                    Using the menu on the left, click on "Website Management", then click on the “Contests” link. This will take you to the Contest Listing Page. <br />
                                    <img src="/img/documentation-img/ContestImg/navbar.png" class="userImage" />
                                </li>
                                <li class="createList">
                                    In the Contest Listing Page, click on any contest listing of your choice. This will take you to the View Contest Details. <br />
                                    <img src="/img/documentation-img/ContestImg/listing_select.png" class="userImage" />
                                </li>

                                <li class="createList">
                                    In Contest Details Page, you will be able to see the following fields:
                                    <ul class="unorderedList">
                                        <li>
                                            Contest Code
                                        </li>
                                        <li>
                                            Contest Name
                                        </li>
                                        <li>
                                            Contest Category
                                        </li>
                                        <li>
                                            Contest Start
                                        </li>
                                        <li>
                                            Contest End
                                        </li>
                                        <li>
                                            Display Start
                                        </li>
                                        <li>
                                            Display End
                                        </li>
                                        <li>
                                            Contest Description
                                        </li>
                                        <li>
                                            Contest Terms and Conditions
                                        </li>
                                        <li>
                                            Contest Image
                                        </li>
                                        <li>
                                            Display Weight
                                        </li>
                                        <li>
                                            Contest Q&A Link
                                        </li>

                                    </ul>
                                    <div class="alert alert-primary" role="alert">
                                        <i class="fas fa-info-circle" aria-hidden="true"></i>
                                        <strong class="noteHeader">Information:</strong><br/><br/>
                                            - Display weight determines how the item will be displayed. The lower the display weight, the higher it will place on the website.<br />
                                            - Display Start should always be earlier than Display End.<br />
                                            - The value in Display Start must precede value in Contest Start.<br />
                                            - The value in Contest End must precede value in Display End. <br />
                                            - Contest Description and Contest Terms and Conditions should be in HTML format.
                                </div>
                            </li>

                            </ol>
                            <div className="text-right">
                                <a href="/documentation/contests/CreateContestHelp" className="btn btn-primary">Create Contests &raquo;</a>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
        );
    }
}